import { render, staticRenderFns } from "./To_do_lists.vue?vue&type=template&id=356a2b60&scoped=true"
import script from "./To_do_lists.vue?vue&type=script&lang=js"
export * from "./To_do_lists.vue?vue&type=script&lang=js"
import style0 from "./To_do_lists.vue?vue&type=style&index=0&id=356a2b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a2b60",
  null
  
)

export default component.exports